import { Descriptions, RadioChangeEvent } from "antd";
import _, { words } from 'lodash';
import moment from "moment";
import QueryString from "qs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { getEvaluationItems, getWritingEvaluationItems } from "../../api/mypage.api";
import { createSpeakingFeedback, createWritingFeedback, getSavedComments, getSavedFeedback, getStudentFile, getStudentFiles, getStudentWriting } from "../../api/tutor.api";
import Button from "../../components/Button";
import Loader from "../../components/Loader";
import ConfirmModal from "../../components/modals/ConfirmModal";
import CommentEditor from "../../components/tutor/assess/CommentEditor";
import EvaluationItem from "../../components/tutor/assess/EvaluationItem";
import ShowSttModal from "../../components/tutor/assess/modals/ShowSttModal";
import useAxios from "../../hooks/useAxios";
import useNotification from "../../hooks/useNotification";
import { IGetEvaluationItems } from "../../models/mypage.model";
import { IGetSavedComments, IGetSavedFeedback } from "../../models/tutor.model";
import WritingAdvisor from '../../components/tutor/assess/WritingAdvisor';
import { useLazyGetProofreadingQuery, useGetReviewedContentQuery, useGetCorrectionResultCountQuery } from '../../api/edutem/edutem.api';
import TeacherFeedback from '../../components/tutor/assess/TeacherFeedback';
import {
  useGetSaveCorrectTextQuery,
  useLazyGetCorrectTextQuery,
  useSaveCorrectTextMutation,
} from '../../api/united-associates/united-associates.api';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import AIProofreadingGuide from '../../components/tutor/assess/modals/AIProofreadingGuide';
import useUtil from '../../hooks/useUtil';
import OverallWordCheckModal from '../../components/tutor/assess/modals/OverallWordCheckModal';

const Block = styled.div`
  .header-box {
    width: 200px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #e8e8e8;
    text-align: center;
  }

  .box-2 {
    padding-top: 5px;
    line-height: 15px;
  }

  .writing-box {
    height: 60vh;
    padding: 5px;
    font-size: 14px;
    overflow-y: auto;

    .sentence {
      white-space: pre-wrap;
    }
  }
`;


/**
 * 피드백 타입 유형
 */
interface I_FEEDBACK_TYPE {
  [index: string]: string;
}

export const FEEDBACK_TYPE: I_FEEDBACK_TYPE = {
  SPEECH_TEACHER: "ST",
  WRITING_TEACHER: "WT",
  WRITING_AND_SPEAKING_TEACHER: "WS"
}

export const COMPLETE_TYPE = {
  STAND_BY: "SB",
  COMPLETED: "CP"
}

/**
 * ACTIVITY 유형
 * TI 공통코드 ID0010
 */
interface I_ACTIVITY_TYPE {
  [index: string]: string;
}

export const ACTIVITY_TYPE: I_ACTIVITY_TYPE = {
  /**
   * 일반 컨텐츠
   */
  GENERAL_CONTENTS: "CT",
  /**
   * 숙제
   */
  HOMEWORK: "HW",
  /**
   * 포트폴리오
   */
  PORTFOLIO: "PF",
  /**
   * 형성평가
   */
  FORMATIVE_ASSESSMENT: "FA",
  /**
   * 자유발화
   */
  FREE_SPEECH: "FS"
}

/**
 * Typescript 의 interface 를 선언하여 불필요한 형변환 제거
 */
export interface IQueryParams {
  rubricNo: number;
  resultCode: number;
  learningTlStructureNo: number;
  seq: number;
  activityCode: number;
  curriculumName: string;
  studentKorName: string;
  studentEngName: string;
  regDate: string;
  displayName: string;
  activityName: string;
  activityType: string;
  feedbackTypeCode: string;
  eduStepCode: string;
  isReadOnly: boolean;
}
const TutorAssess = () => {
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true }) as unknown as IQueryParams;

  const {
    rubricNo,
    resultCode,
    learningTlStructureNo,
    seq,
    activityCode,
    curriculumName,
    studentKorName,
    studentEngName,
    regDate,
    displayName,
    activityName,
    activityType,
    feedbackTypeCode,
    eduStepCode,
    isReadOnly
  } = query;

  const { t, i18n } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { getCookie } = useUtil();

  /**
   * 기존 데이터 불러오는 소스.. 변수 이름 변경 요망
   */
  const { infoNotification, successNotification, errorNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetEvaluationItems>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<any>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetSavedFeedback>();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios<IGetSavedComments>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();
  const { data: submitRes2, isLoading: submitIsLoading2, error: submitError2, execute: submitExecute2 } = useAxios();

  const [data, setData] = useState<any[]>([]);
  const [answers, setAnswers] = useState<string[]>([]);
  const [comment, setComment] = useState('');
  const [revision, setRevision] = useState('');
  const [revisions, setRevisions] = useState<string[]>([]);
  const [step, setStep] = useState(1);
  const [showSttVisible, setShowSttVisible] = useState(false);
  const [recogSentence, setRecogSentence] = useState('');
  const [confirmSubmitVisible, setConfirmSubmitVisible] = useState(false);

  /**
   * 새로 추가되는 부분 2024-03-19
   * @param feedbackTypeCode
   */
  const [_sentences, setSentences] = useState<any>([]);
  const [_sentencesAll, setSentencesAll] = useState<any>([]);
  const [advisorSentences, setAdvisorSentences] = useState<any>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isWordCountModalOpen, setIsWordCountModalOpen] = useState<boolean>(false);
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const [isAllSentenceFirst, setIsAllSentenceFirst] = useState<boolean>(true);
  const [isAdvisorOpen, setIsAdvisorOpen] = useState<boolean>(false);
  const [originalWordCount, setOriginalWordCount] = useState<number>(0);
  const [errorWordCount, setErrorWordCount] = useState<number>(0);
  const [rewriteOriginalWordCount, setRewriteOriginalWordCount] = useState<number>(0);
  const [rewriteErrorWordCount, setRewriteErrorWordCount] = useState<number>(0);
  const OVERALL_ASSESSMENT_DEFAULT: string = 'Keep up the good work!';

  /**
   * Edutem API
   */
  const [proofread, { currentData, isLoading: isProofreadLoading, isFetching: isProofreadFetching, error: proofreadError }] = useLazyGetProofreadingQuery();
  const [proofreadAll, { currentData: proofreadAllData, isLoading: isProofreadAllLoading, isFetching: isProofreadAllFetching, error: proofreadAllError }] = useLazyGetProofreadingQuery();

  const { data: getReviewedResponse, isLoading: isReviewedLoading } = useGetReviewedContentQuery(res2?.data?.reviewedCode, { skip: !res2?.data?.reviewedCode })
  /**
   * United Associates API
   */
  const { data: getAdvisorSaveTexts, isLoading: isAdvisorTextLoading } = useGetSaveCorrectTextQuery(res2?.data?.studentAnswer?.map((item:any) => {
      return {...item, quizResultCode: res2?.data?.quizResultCode }
    }), { skip: !res2?.data });
  const [correction, { currentData: adviosrCurrentData, isLoading: isCorrectionLoading, isFetching: isCorrectionFetching, error: correctionError }] = useLazyGetCorrectTextQuery();
  const [saveCorrectText, { isLoading: isUASaveLoading }] = useSaveCorrectTextMutation();
  const isSpeechFeedback = (feedbackTypeCode: string) => FEEDBACK_TYPE.SPEECH_TEACHER === feedbackTypeCode;
  const isFreeSpeech = (activityType: string) => ACTIVITY_TYPE.FREE_SPEECH === activityType;
  const isRewrite = (activityName: string) => activityName === 'Rewrite';
  const hasUASaveData = (comment: any) => (comment!.uaRevisedSentence && comment!.uaSimilarSentence);
  const hasEduTemSaveData = (comment: any, index: number) => {
    return !!comment.eduTemRevisedSentence;
  }
  const _isRewrite = isRewrite(activityName);

  const { data: getCorrectionCountResponse } = useGetCorrectionResultCountQuery({
    rubricNo,
    resultCode,
    learningTlStructureNo,
    seq,
    activityCode,
    isRewrite: _isRewrite
  }, { skip: !resultCode || !learningTlStructureNo });


  /**
   * Rewrite 일 때, 저장 되어 있는 선행학습의 단어 카운트와 단어 카운트를 가져와서 넣어주는 작업
   */
  useEffect(() => {
    if (!getCorrectionCountResponse) return;

    const { originalWordCount, errorWordCount, rewriteErrorWordCount, rewriteOriginalWordCount } = getCorrectionCountResponse || {};
    setOriginalWordCount(originalWordCount || 0);
    setErrorWordCount(errorWordCount || 0);
    setRewriteErrorWordCount(rewriteErrorWordCount || 0);
    setRewriteOriginalWordCount(rewriteOriginalWordCount || 0);

    console.log("originalWordCount");

  }, [getCorrectionCountResponse]);


  const proofreadExecute = () => {
    if (currentData) {
      proofread(currentData?.map((sentence: any) => {
        return { text: sentence.text }
      }))
      return;
    }

    console.log("_sentences", _sentences);

    proofread(_sentences?.map((sentence: string) => {
      return { text: sentence?.replace(/(<[^>]*>|&nbsp;)?/g, '') }
    }))
  }

  const onProofread = () => {
    if (!isFirst && getCookie(auth.memberCode) == null) {
      setIsOpen(true);
      return;
    }

    proofreadExecute();
  }

  const onProofreadAll = () => {
    const original = res2?.data?.studentAnswer?.map((item: any) => item.userAnswer)
      ?.filter((sentence: any) => sentence != null);
    if (proofreadAllData) {
      proofreadAll(proofreadAllData?.map((sentence: any) => {
        const text = sentence.text;
        return { text }
      }))
      return;
    }

    if (!original || (original && original.length === 0)) return;

    setIsAllSentenceFirst(false);
    proofreadAll(original?.map((sentence: string) => {
      return { text: sentence?.replace(/(<[^>]*>|&nbsp;)?/g, '') }
    }));
  }

  /**
   * 에듀템 API로 나온 결과를 Replace하여 태그로 감싸는 작업
   * @param sentence
   */
  const getCorrectText = (sentence: any) => {
    let result: string = '';
    let editorResult: string = '';
    let lastIndex = 0;

    console.log("sentence", sentence);

    for (let match of sentence?.matches) {
      let offset = match.offset;
      let replacement = match.replacements?.at(0).value;
      if (!replacement) continue;

      let length = match.length;


      // 변경되지 않은 부분을 결과에 추가
      result += sentence.text.substring(lastIndex, offset);
      // 변경된 부분을 <span className="edt-a"> 태그로 감싸서 추가
      result += `<span class="edt-b">${sentence.text.substring(offset, (offset + length))}</span>`;
      // 기존 단어를 <span className="edt-b"> 태그로 감싸서 추가
      result += `<span class="edt-a">${replacement}</span>`;


      // 변경되지 않은 부분을 결과에 추가
      editorResult += sentence.text.substring(lastIndex, offset).replace("    ", "&nbsp;&nbsp;&nbsp;&nbsp;");
      // 변경된 부분을 Tinymce 에디터에 맞게 태그로 감싸서 추가
      editorResult += `<span style="color: #e03e2d;"><del><strong>${sentence.text.substring(offset, offset + length)}</strong></del></span>`;
      // 기존 단어를 Tinymce 에디터에 맞게 태그로 감싸서 추가
      editorResult += `<span style="color: #236fa1; background-color: #c2e0f4;"><strong>${replacement}</strong></span>`;

      lastIndex = offset + length;
    }

    // 남은 부분을 결과에 추가
    result += sentence.text.substring(lastIndex);
    editorResult += sentence.text.substring(lastIndex);

    return { editorText: editorResult, __html: result };
  };


  /**
   * 데이터 로딩?
   */
  useEffect(() => {
    const langCode = i18n.language === 'ko' ? 'kr' : 'en';

    switch (feedbackTypeCode) {
      case 'ST':
        execute(getEvaluationItems(langCode, rubricNo))
        execute2(
          activityType === 'FS'
            ? getStudentFiles(resultCode, activityType)
            : getStudentFile(resultCode, activityType)
        )
        break;
      case 'WT':
      case 'WS':
        execute(getWritingEvaluationItems(langCode, rubricNo));
        execute2(getStudentWriting(resultCode));
        break;
    }

    execute3(getSavedFeedback(resultCode));
    execute4(getSavedComments(resultCode, feedbackTypeCode));
  }, []);

  useEffect(() => {
    if (res) {
      const _data: any = [];

      if (feedbackTypeCode === FEEDBACK_TYPE.SPEECH_TEACHER) {
        res.data?.evaluationList?.forEach(item => {
          item.evaluationItem.forEach((subitem: any) => {
            subitem.parentItemName = item.parentEvaluationItemName?.trim();
            _data.push(subitem);
          });
        });
      } else {
        res.data?.evaluationWritingList?.forEach((item: any) => {
          if (item.treeLevel < 5) {
            item.parentItemName = item.parentEvaluationItemName?.trim();
          } else {
            item.parentItemName = item.grandfatherEvaluationItemName?.trim();
          }          
          _data.push(item);
        });
      }

      setData(_.sortBy(_data, 'evaluationNo'));
    }
  }, [res]);

  /**
   * 에디터에 데이터 넣는 작업?
   */
  useEffect(() => {
    if (res2?.data?.studentAnswer && res4?.data?.wtSentenceRevisionInfo) {
      const sentences = res2?.data?.studentAnswer?.map((item: any) => item.userAnswer);
      const newRevisions = res4.data.wtSentenceRevisionInfo.map(item => item.writingSentenceRevision);

      sentences.forEach((sentence: string, index: number) => {
        if (!newRevisions[index] && !isReadOnly) {
          newRevisions[index] =
            sentence?.replaceAll("    ", "&nbsp;&nbsp;&nbsp;&nbsp;")
              ?.replaceAll("\n", "</div><div>");
        }
      });

      console.log(newRevisions);
      const _sentences = res2?.data?.studentAnswer?.map((item: any) => item.eduTemRevisedSentence ? item.eduTemRevisedSentence : item.userAnswer);

      setRevisions(newRevisions);
      setSentences(_sentences);
      setSentencesAll(res2?.data?.studentAnswer?.map((item: any) => item.userAnswer));
      setAdvisorSentences(res2?.data?.studentAnswer?.map((item: any) => {
        return { data : { corrected_text: item.userAnswer, similar_text: '' } }
      }));
    }
  }, [res2, res4]);

  useEffect(() => {
    if (res3?.data && data.length) {
      const _answers: any[] = [];
      res3.data.evaluations?.forEach(item => {
        _answers.push(`${item.evaluationNo}-${item.scaleCode}`);
      });

      if (data.length > _answers.length) {
        const index = data.findIndex((item: any) => item.bonusYn === 'Y');
        const evaluationNo = data.find((item: any) => item.bonusYn === 'Y')?.evaluationNo;
        if (index !== -1) _answers.splice(index, 0, `${evaluationNo}-n`);
      }

      setAnswers(_answers);

      if (res3.data?.teacherComment) {
        setComment(res3.data.teacherComment);
      }
      if (res3.data?.sentenceRevision) {
        setRevision(res3.data.sentenceRevision);
      }
    }
  }, [res3, data]);

  useEffect(() => {
    if (!res4?.data) return;

    if (res4.data?.teacherComment) {
      setComment(res4.data.teacherComment);
    }

    if (res4.data?.speakingSentenceRevision) {
      setRevision(res4.data.speakingSentenceRevision);
    }
  }, [res4]);

  useEffect(() => {
    if (!submitRes) return;

    successNotification(t('common.message.save1'));
  }, [submitRes]);

  useEffect(() => {
    if (!submitRes2) return;

    alert(t('class.tutor.message1'));
    window.opener.postMessage('success', '*');
    window.close();

  }, [submitRes2]);

  /**
   * 각 액티비티에 따른 플로우 스탭 세팅
   */
  useEffect(() => {
    if (isSpeechFeedback(feedbackTypeCode) || isRewrite(activityName)) {
      setStep(2);
    }
  }, [feedbackTypeCode]);

  useEffect(() => {
    document.body.style.backgroundColor = 'white';
    const navbar = document.querySelector('nav.main-header');
    if (navbar) navbar.classList.add('d-none');
    const sidebar = document.querySelector('div.main-sidebar');
    if (sidebar) sidebar.classList.add('d-none');

    document.addEventListener('play', onPlay, true);
    return () => document.removeEventListener('play', onPlay, true);
  }, []);


  useEffect(() => {
    if (currentData) {
      let _map = [];
      if (isFirst) {
       _map = currentData?.map((sentence: any) => {
          const { editorText } = getCorrectText(sentence);
          return editorText;
        });

        setRevisions(_map);
        setIsFirst(false);
      }

      _map = currentData?.map((sentence: any) => {
        const { __html } = getCorrectText(sentence);
        return __html;
      });

      setSentences(_map);
    }
  }, [currentData]);

  useEffect(() => {
    if (proofreadAllData) {
      let _map = proofreadAllData?.map((sentence: any) => {
        const { __html } = getCorrectText(sentence);
        return __html;
      });

      console.log("_map", _map);
      setSentencesAll(_map);


      const _data = proofreadAllData;


      let _originalWordCount = res2?.data?.studentAnswer?.map((item:any) => item.userAnswer)
        .reduce((acc: number, cur: any) => {
        const wordCount = cur.split(' ').filter((text:string) => text).length;
        return acc + wordCount;
      }, 0);

      console.log(_originalWordCount)

      let _errorWordCount = _data.reduce((acc: number, cur: any) => {
        const wordCount = cur.matches?.filter((item: any) => {
          const emptyFilter = item.replacements?.map((word: any) => word.value)
            .filter((word: string) => word);
          return emptyFilter.length > 0;
        }).length;

        return acc + wordCount;
      }, 0);

      if (isRewrite(activityName)) {
        setRewriteOriginalWordCount(_originalWordCount);
        setRewriteErrorWordCount(_errorWordCount);
      } else {
        setOriginalWordCount(_originalWordCount);
        setErrorWordCount(_errorWordCount)
      }
    }
  }, [proofreadAllData]);

  useEffect(() => {
    if (!proofreadError || !proofreadAllError) return;

    errorNotification(proofreadError.data.errorMessage);
  }, [proofreadError, proofreadAllError]);

  useEffect(() => {
    if (!isAdvisorOpen) return;

    //이미 API로 불러온 결과가 있을 때
    if (adviosrCurrentData) return;

    //저장 된 UA결과가 있을 때
    if (getAdvisorSaveTexts && (getAdvisorSaveTexts.length > 0 && getAdvisorSaveTexts.every(hasUASaveData))) return;

    correction(advisorSentences.map((sentence: any) => {
      return { text: sentence?.data?.corrected_text }
    }));
  }, [isAdvisorOpen]);

  useEffect(() => {
    if (!adviosrCurrentData) return;

    const _data = adviosrCurrentData.map((_res: any, index: number) => {
      const { similar_text: uaSimilarSentence, corrected_text: uaRevisedSentence } = _res?.data;
      const { quizResultCode, studentAnswer } = res2?.data;
      const { quizSeq: seq, userAnswerSeq } = studentAnswer[index];

      return {
        quizResultCode,
        seq,
        userAnswerSeq,
        uaSimilarSentence,
        uaRevisedSentence,
        teacherMemCode: auth.memberCode
      }
    })

    //저장 된 UA결과가 있을 때 저장 안함
    if (getAdvisorSaveTexts && (getAdvisorSaveTexts.length > 0 && getAdvisorSaveTexts.every(hasUASaveData))) return;

    saveCorrectText(_data);
  }, [adviosrCurrentData]);

  useEffect(() => {
    if (isSpeechFeedback(feedbackTypeCode)) return;

    if (step === 1) return;

    if (proofreadAllData) return;
    /**
     * 미리 저장 된 에듀템 전문이 있을경우 다시 AI를 돌리지 않는다.
     */

    console.log("getReviewedResponse", getReviewedResponse)

    if (isReviewedLoading) return;

    if (getReviewedResponse) {
      setSentencesAll(getReviewedResponse.reviewedContent.split("\n"));
      return;
    }

    if (isReadOnly) return;

    onProofreadAll();
  }, [step, res2, getReviewedResponse]);

  useEffect(() => {
    if (!getAdvisorSaveTexts) return;

    if (getAdvisorSaveTexts.length === 0) return;

    if (!getAdvisorSaveTexts.every(hasEduTemSaveData)) return;

    setIsFirst(false);
  }, [getAdvisorSaveTexts]);

  const onPlay = (e: any) => {
    const audios = document.getElementsByTagName('audio');
    for (let i = 0; i < audios.length; i++) {
      if (audios[i] !== e.target){
        audios[i].pause();
      }
    }
  }

  const onSetAnswer = (
    { target: { value } }: RadioChangeEvent,
    index: number,
  ) => {
    const newAnswers = [...answers];
    newAnswers[index] = value;
    setAnswers(newAnswers);
  };

  const onCheckAnswers = () => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].bonusYn === 'N') {
        let isIncluded = false;
        for (let j = 0; j < answers.length; j++) {
          if (answers[j] && answers[j].includes(`${data[i].evaluationNo}-`)) {
            isIncluded = true;
          }
        }
        if (!isIncluded) return false;
      }
    }

    return true;
  }

  const renderStudentWriting = () => {
    return (
      _sentencesAll?.map((sentence: any, index: number) => (
        <div key={index} className="bx" dangerouslySetInnerHTML={{__html: sentence}} />
      ))
    )
  }

  const showStepButton = () => {
    return (feedbackTypeCode === FEEDBACK_TYPE.WRITING_TEACHER && activityName !== 'Rewrite')
      || feedbackTypeCode === FEEDBACK_TYPE.WRITING_AND_SPEAKING_TEACHER;
  };

  const onNext = () => {
    setStep(2);
  }

  const onSubmit = (completeStatus: string) => {
    setConfirmSubmitVisible(false);
    if (isReadOnly) return ;

    if (completeStatus === COMPLETE_TYPE.COMPLETED) {
      const result = onCheckAnswers();
      if (!result) return infoNotification(t('class.tutor.message2'));
    }

    if (displayName === 'Creative Speaking' && activityName !== 'Retry') {
      if (!comment || !revision) {
        return infoNotification(t('class.tutor.message3'));
      }
      if (revision.length > 2000) {
        return infoNotification(`(Sentence Revision) ${t('class.tutor.message4')}`);
      }
    }

    let req: any = {
      resultCode,
      completeStatus,
      learningTlStructureNo,
      seq,
      activityName,
      activityCode,
      evaluationReq: [],
    };

    answers.forEach(item => {
      const split = item?.split('-');
      // split[1] = 'n' 이면 선택하지 않은 항목이므로 제외
      if (split && split[1] !== 'n') {
        req.evaluationReq.push({
          evaluationNo: Number(split[0]),
          scaleCode: split[1],
        });
      }
    });

    if (activityName !== 'retry') {
      req.teacherComment = comment;
      req.sentenceRevision = revision;
    }

    if (feedbackTypeCode === FEEDBACK_TYPE.WRITING_TEACHER || feedbackTypeCode === FEEDBACK_TYPE.WRITING_AND_SPEAKING_TEACHER) {
      req.teacherComment = comment ? comment : OVERALL_ASSESSMENT_DEFAULT;

      for (let i = 0; i < revisions.length; i++) {
        if (revisions[i]?.replace(/(<[^>]*>|&nbsp;)?/g, '').length > 2000) {
          return infoNotification(`(Sentence Revision #${i + 1}) ${t('class.tutor.message4')}`);
        }

        if (revisions[i]?.length > 4000) {
          return infoNotification(`(Sentence Revision #${i + 1}) 줄바꿈이 너무 많습니다.`);
        }

      }

      const arr: any[] = [];
      _.cloneDeep(res2?.data?.studentAnswer)?.forEach((item: any, index: number) => {
        item.quizResultCode = res2?.data?.quizResultCode;
        item.sentenceRevision = revisions[index];

        // 에듀템 번역 원본 저장?
        if (_sentences && _sentences.length > 0) {
          item.eduTemRevisedSentence = _sentences[index];
        }

        arr.push(item);
      });

      req.writingSentenceRevision = arr;
    }

    if (_sentencesAll && !isAllSentenceFirst) {
      req.reviewed = {
        quizResultCode: res2?.data?.quizResultCode,
        reviewedType: 'EDU_TEM',
        reviewedContent: _sentencesAll.join('\n'),
      }
    }

    req = {...req, originalWordCount, errorWordCount}

    if (isRewrite(activityName)) {
      req = {...req, rewriteOriginalWordCount, rewriteErrorWordCount}
    }

    /**
     * 실제 데이터 처리가 이루어짐
     * 왜 이렇게 똑같은 로직을 2개로 나누었는지 궁금하긴함.
     */
    feedbackTypeCode === FEEDBACK_TYPE.SPEECH_TEACHER
      ? completeStatus === COMPLETE_TYPE.STAND_BY
        ? submitExecute(createSpeakingFeedback(rubricNo, req))
        : submitExecute2(createSpeakingFeedback(rubricNo, req))
      : completeStatus === COMPLETE_TYPE.STAND_BY
        ? submitExecute(createWritingFeedback(rubricNo, req))
        : submitExecute2(createWritingFeedback(rubricNo, req));
    console.log(originalWordCount, errorWordCount);
  }

  const createReportButton = () => {

    const generateButton = (onClickFunc: any, disabledStatus: boolean, textContent: string) => (
      <Button
        className="btn btn-primary btn-w100p ml-1"
        onClick={onClickFunc}
        text={t(textContent)}
        disabled={disabledStatus}
      />
    );

    const getOnClick = () => {
      if (step === 2) {
        if (isRewrite(activityName)) {
          return () => setIsWordCountModalOpen(true);
        } else {
          return () => setConfirmSubmitVisible(true);
        }
      } else {
        return () => setConfirmSubmitVisible(true);
      }
    };

    const getText = () => {
      if (step === 2 && isRewrite(activityName)) {
        return 'common.button.next';
      } else {
        return 'class.tutor.button5';
      }
    };

    const getDisabled = () => {
      const isLoadingOrFetching = isCorrectionLoading || isCorrectionFetching || isUASaveLoading || isProofreadAllLoading || isProofreadAllFetching;
      if (step === 2) {
        if (isRewrite(activityName)) {
          return isLoadingOrFetching;
        } else {
          return isReadOnly || isLoadingOrFetching;
        }
      } else {
        if (isRewrite(activityName)) {
          return isReadOnly || isLoadingOrFetching;
        } else {
          return isReadOnly || isLoadingOrFetching;
        }
      }
    };

    if (feedbackTypeCode === FEEDBACK_TYPE.WRITING_TEACHER) {
      return step === 1 ? null : generateButton(getOnClick(), getDisabled(), getText());
    } else {
      return generateButton(() => setConfirmSubmitVisible(true), isReadOnly || getDisabled(), 'class.tutor.button5');
    }
  }

  useEffect(() => {
    console.log(proofreadAllError);
    if (proofreadAllError?.data) {
      if (proofreadAllError.status === 500) {
        errorNotification(`공격적인 언어 및 부적절한 단어가 포함되어 에듀템에서 첨삭을 거부하였습니다.`);
        return;
      }

      errorNotification(proofreadAllError.data.error);
      return;
    }
  }, [proofreadAllError]);

  return (
    <>
      <Helmet>
        <title>Assessment</title>
      </Helmet>
      <div className="box">
        <div className="writing-box-wrap">
          <div className="flex mb-5">
            <div className="header-box">Assessment</div>
            <div className="header-box box-2">
              {displayName}
              <br />
              {activityName}
            </div>
            <div className="header-box">{feedbackTypeCode === FEEDBACK_TYPE.SPEECH_TEACHER ? 'Speaking' : 'Writing'} {curriculumName}</div>
          </div>
          <div className="col-desc">
            <dl>
              <dt>Name :</dt>
              <dd>{studentKorName} ({studentEngName})</dd>
            </dl>
            <dl>
              <dt>Submitted on :</dt>
              <dd>{moment(regDate).format('YYYY-MM-DD')}</dd>
            </dl>
          </div>
          {/* 실제 컨텐츠 영역 */}
          <div className="row flex-nowrap position-relative">
            {isLoading || isLoading2 || isLoading3 || isLoading4 || submitIsLoading || submitIsLoading2 ? <Loader /> : null}
            {
              step === 1 ? (
                <>
                  <div className={`adv-layer-wrap position-relative ${isAdvisorOpen ? 'active' : ''}`}>
                    { isCorrectionLoading || isCorrectionFetching || isUASaveLoading ? <Loader /> : null }
                    <div className="side-btn-area">
                      <button type="button" className={`btn-adv`} disabled={isReadOnly} onClick={() => {
                        if (isReadOnly) return;

                        setIsAdvisorOpen(true);
                      }}>
                        Writing Advisor
                      </button>
                    </div>
                    <div className="layer-header">
                      <h1>Writing Advisor</h1>
                      <button type="button" className="close-button" onClick={() => setIsAdvisorOpen(false)}>
                        <svg
                          fillRule="evenodd"
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="close"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path>
                        </svg>
                      </button>
                    </div>
                    <div className="layer-body">
                      <WritingAdvisor
                        sentences={(getAdvisorSaveTexts && getAdvisorSaveTexts.length > 0 ?  getAdvisorSaveTexts.map((item: any) => {
                          return {...item, data: {
                            corrected_text: item.uaRevisedSentence, similar_text: item.uaSimilarSentence
                          }}
                        }) : null ) ?? adviosrCurrentData ?? advisorSentences}
                      />
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <div className="writing-frame text-center position-relative">
                      { isProofreadLoading || isProofreadFetching ? <Loader /> : null }
                      <TeacherFeedback
                        sentences={_sentences}
                        revisions={revisions}
                        onProofread={onProofread}
                        setRevisions={setRevisions}
                        feedbackTypeCode={feedbackTypeCode}
                        isReadOnly={isReadOnly}
                      />
                    </div>
                  </div>
                </>

              ) : (
                <div className="row w-100">
                  <div className="col-6 pr-3">
                    <div className="writing-frame position-relative">
                      { isReviewedLoading || isProofreadAllLoading || isProofreadAllFetching ? <Loader /> : null }
                      {
                        isSpeechFeedback(feedbackTypeCode)
                          ? (
                            isFreeSpeech(activityType)
                              ? (
                                res2?.data?.map((item: any, index: number) => (
                                  <div className="flex justify-content-center mb-2" key={index}>
                                    <audio
                                      controls
                                      src={item.file?.fileLocation}
                                    />
                                    <Button
                                      className="btn btn-info mt-3 ml-2"
                                      onClick={() => {
                                        setRecogSentence(item.recogSentence);
                                        setShowSttVisible(true);
                                      }}
                                      text="STT"
                                    />
                                  </div>
                                ))
                              ) : (
                                <div>
                                  <div>
                                    <ReactPlayer
                                      url={res2?.data?.file?.fileLocation}
                                      width="100%"
                                      height="579px"
                                      controls
                                    />
                                  </div>
                                </div>
                              )
                          ) : (
                            <>
                              <div className="text-right">
                                <button
                                  type="button"
                                  className="btn btn-primary mb-3"
                                  onClick={onProofreadAll}
                                  disabled={isReadOnly}
                                >
                                  <i className="ic">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                    >
                                      <path fill="none" d="M0 0h19.1v19.1H0V0z" />
                                      <path
                                        fillRule="evenodd"
                                        fill="#FFF"
                                        d="M17.848 17.852a.501.501 0 0 1-.707 0l-2.198-2.198a3.977 3.977 0 0 1-2.45.844 4.005 4.005 0 0 1-4.001-3.999 4.006 4.006 0 0 1 4.001-4.001 4.005 4.005 0 0 1 4.001 4.001 3.97 3.97 0 0 1-.844 2.448l2.198 2.198a.499.499 0 0 1 0 .707zm-5.355-8.354c-1.655 0-3 1.346-3 3.001a3.003 3.003 0 0 0 3 2.999 3.005 3.005 0 0 0 3.002-2.999 3.005 3.005 0 0 0-3.002-3.001zm0 1.501a1.5 1.5 0 0 0-1.499 1.5.5.5 0 0 1-1.001 0c0-1.379 1.122-2.5 2.5-2.5a.5.5 0 1 1 0 1zM4.957 5.261a.664.664 0 0 1 1.204 0l1.321 2.838a.463.463 0 0 1-.421.659h-.006a.462.462 0 0 1-.427-.28l-.197-.458H4.677l-.193.457a.465.465 0 1 1-.849-.378l1.322-2.838zm1.148 1.951-.541-1.283h-.022l-.535 1.283h1.098zm-2.013 6.907h2.2a.5.5 0 0 1 0 1h-2.2a.5.5 0 1 1 0-1zm0-3.18h2.7a.5.5 0 1 1 0 1h-2.7a.5.5 0 1 1 0-1zM8.63 4.877c.283 0 .514.231.514.515v2.852a.514.514 0 1 1-1.03 0V5.392c0-.284.231-.515.516-.515zm4.912 2.822a.357.357 0 0 1-.357-.357V5.026h-1.871a.386.386 0 0 1-.385-.385v-1.87H2.763v14.455h6.975c.196 0 .355.16.355.357v.046a.356.356 0 0 1-.355.355l-7.331.015a.394.394 0 0 1-.386-.387l-.03-15.228c0-.208.179-.386.387-.386h8.906c.089 0 .179.03.238.09.03.029 2.287 2.255 2.287 2.286.058.059.088.118.088.177v2.791c0 .197-.16.357-.355.357zM11.67 3.275v.95h.95l-.95-.95z"
                                      />
                                    </svg>
                                  </i>
                                  AI Proofreading
                                </button>
                              </div>

                              <div className="text-content">
                                {renderStudentWriting()}
                              </div>
                            </>
                          )
                      }
                    </div>
                  </div>
                  <div className="col-6">
                    {
                      data.map((item: any, index: number) => (
                        <EvaluationItem
                          item={item}
                          index={index}
                          answers={answers}
                          onSetAnswer={onSetAnswer}
                          isReadOnly={isReadOnly}
                        />
                      ))
                    }
                    {
                      ((feedbackTypeCode === FEEDBACK_TYPE.WRITING_TEACHER && isRewrite(activityName)) ||
                      (displayName === 'Creative Speaking' && !isRewrite(activityName)))
                        && (
                        <div className="mb-4">
                          <div className="tox-editor-item">
                            <CommentEditor
                              comment={comment}
                              setComment={setComment}
                              feedbackTypeCode={feedbackTypeCode}
                              revision={revision}
                              setRevision={setRevision}
                              isRewrite={isRewrite(activityName)}
                              displayName={displayName}
                            />
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              )
            }
          </div>
          <div className="text-right mt-2">
            <Button
              className="btn btn-secondary btn-w100p ml-1"
              onClick={window.close}
              text={t('common.button.close')}
            />
            {showStepButton() && step === 1
              ? (
                <>
                <Button
                    className="btn btn-info btn-w100p ml-1"
                    onClick={onNext}
                    disabled={isCorrectionLoading || isCorrectionFetching || isUASaveLoading || isProofreadAllLoading || isProofreadAllFetching || proofreadAllError?.data}
                    text={t('common.button.next')}
                  />
                </>
              )
              : (
                <>
                  {showStepButton() &&
                    <Button
                      className="btn btn-info btn-w100p ml-1"
                      onClick={() => setStep(1)}
                      text={t('common.button.back')}
                      disabled={isCorrectionLoading || isCorrectionFetching || isUASaveLoading || isProofreadAllLoading || isProofreadAllFetching || proofreadAllError?.data}
                    />
                  }
                </>
              )
            }
            <Button
              className="btn btn-info btn-w100p ml-1"
              onClick={() => onSubmit(COMPLETE_TYPE.STAND_BY)}
              text={t('common.button.save')}
              disabled={isReadOnly || isCorrectionLoading || isCorrectionFetching || isUASaveLoading || isProofreadAllLoading || isProofreadAllFetching}
            />
            {
              createReportButton()
            }
          </div>
        </div>
      </div>
      {showSttVisible &&
        <ShowSttModal
          visible={showSttVisible}
          setVisible={setShowSttVisible}
          recogSentence={recogSentence}
        />
      }
      {confirmSubmitVisible &&
        <ConfirmModal
          visible={confirmSubmitVisible}
          setVisible={setConfirmSubmitVisible}
          onConfirm={() => onSubmit(COMPLETE_TYPE.COMPLETED)}
          titleText={t('class.tutor.button5')}
          messageText={t('class.tutor.text3')}
          confirmText={t('common.option.yes')}
          cancelText={t('common.option.no')}
        />
      }
      {
        isOpen && <AIProofreadingGuide isOpen={isOpen} setIsOpen={setIsOpen} onProofreadExecute={proofreadExecute} />
      }
      {
        isWordCountModalOpen && <OverallWordCheckModal
          isOpen={isWordCountModalOpen}
          setIsOpen={setIsWordCountModalOpen}
          onReportSaveSubmit={onSubmit}
          submitType={COMPLETE_TYPE.COMPLETED}
          activityName={activityName}
          displayName={displayName}
          isReadOnly={isReadOnly}
          originalWordCount={originalWordCount}
          errorWordCount={errorWordCount}
          setOriginalWordCount={setOriginalWordCount}
          setErrorWordCount={setErrorWordCount}
          rewriteOriginalWordCount={rewriteOriginalWordCount}
          rewriteErrorWordCount={rewriteErrorWordCount}
          setRewriteOriginalWordCount={setRewriteOriginalWordCount}
          setRewriteErrorWordCount={setRewriteErrorWordCount}
          isOkText={ isRewrite(activityName) && !isReadOnly ? t('class.tutor.button5') : t('common.button.confirm') }
        />
      }
    </>
  );
}

export default TutorAssess;
